import Header from '../Header/Header';
import React, { useCallback, useEffect, useState, useRef } from 'react';

import { Button, Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Selector } from '~/Components/Prospectos/ProspectoDetalhes/Pesquisa/Form';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { DropdownIndicator, customStyles } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';
import Loading from '~/Components/Loading';
import MaskedInput from 'react-text-mask';
import * as constants from '~/constant';
import { FaFileExcel, FaSearch, FaThLarge } from 'react-icons/fa';

import { URLV1 } from '../Navbar/links';
import { salvarEmExcel } from '~/Utils/Helpers';

export default function ImoveisDisponiveis() {
  const [empreendimentoSelecionado, setEmpreendimentoSelecionado] = useState(
    ''
  );
  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [cidadesOpts, setCidadesOpts] = useState([]);
  const [dataLancAnteriorA, setDataLancAnteriorA] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [error, setError] = useState(null);
  const [imoveis, setImoveis] = useState([]);
  const empreendimentos = useSelector(state => state.empreendimentos);

  const optionsEmpreendimentos = [
    ...empreendimentos.sort.map(item => ({
      value: item.codigo,
      label: item.codigo + ' - ' + item.descricao,
    })),
  ];

  const buscarCidades = useCallback(async () => {
    try {
      const response = await api.getCities();

      const opts = response.map(item => ({
        value: item.codigo,
        label: item.cidade,
      }));
      setCidadesOpts(opts);
    } catch (err) {
      setCidadesOpts([]);
    }
  }, []);

  useEffect(() => {
    buscarCidades();
  }, [buscarCidades]);

  const buscarImoveis = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await api.imoveisDisponiveis({
        codigo_familia: empreendimentoSelecionado || 0,
        codigo_cidade: cidadeSelecionada || 0,
        data: dataLancAnteriorA,
      });
      setImoveis(response);
    } catch (err) {
      setError('Erro ao buscar imóveis');
      setImoveis([]);
    } finally {
      setIsLoading(false);
    }
  }, [empreendimentoSelecionado, cidadeSelecionada, dataLancAnteriorA]);

  console.log(imoveis);

  return (
    <>
      <Header title={'Imóveis Disponíveis'} />
      <div className="container-fluid bg-white p-3">
        <Row className="align-items-center">
          <Col md="3">
            <Form.Group>
              <Selector
                label="Empreendimento"
                name="codigo_empreendimento"
                noOptionsMessage={() => 'Nenhum empreendimento encontrado'}
                placeholder={
                  !optionsEmpreendimentos.length ? 'Carregando...' : 'Todos...'
                }
                isDisabled={!optionsEmpreendimentos.length}
                options={optionsEmpreendimentos}
                value={
                  optionsEmpreendimentos.find(
                    opt => opt.value == empreendimentoSelecionado
                  ) || null
                }
                onChange={selectedOption => {
                  setEmpreendimentoSelecionado(
                    selectedOption ? selectedOption.value : ''
                  );
                }}
              />
            </Form.Group>
          </Col>
          <Col md="3">
            <Form.Group>
              <Selector
                label="Cidade"
                name="codigo_cidade"
                placeholder={!cidadesOpts.length ? 'Carregando...' : 'Todos...'}
                isDisabled={!cidadesOpts.length}
                isClearable
                options={cidadesOpts}
                value={
                  cidadesOpts.find(opt => opt.value == cidadeSelecionada) ||
                  null
                }
                onChange={selectedOption => {
                  setCidadeSelecionada(
                    selectedOption ? selectedOption.value : ''
                  );
                }}
                styles={customStyles}
                components={{ DropdownIndicator }}
              />
            </Form.Group>
          </Col>
          <Col md="3">
            <Form.Group>
              <Form.Label>Data de Lanc. Anterior a:</Form.Label>
              <MaskedInput
                name="data_lanc_anterior_a"
                type="tel"
                guide={false}
                className="form-control"
                placeholder="Ex.: 01/01/2019"
                mask={constants.MASK_DATE}
                value={dataLancAnteriorA}
                onChange={e => setDataLancAnteriorA(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col
            md="3"
            className="d-flex justify-content-end mt-3"
            style={{ gap: '1rem' }}
          >
            <Button
              disabled={isLoading}
              className="mt-3"
              variant="primary"
              onClick={buscarImoveis}
            >
              <FaSearch />
              {isLoading ? 'Buscando...' : 'Buscar'}
            </Button>
            <Button
              variant="success"
              className="mt-3"
              disabled={isLoadingExcel || !imoveis.length}
              onClick={async () => {
                try {
                  setIsLoadingExcel(true);
                  await salvarEmExcel(
                    imoveis,
                    '/exportador/excel/relatorio-imoveis-disponiveis'
                  );
                } catch (error) {
                  console.error(error);
                } finally {
                  setIsLoadingExcel(false);
                }
              }}
            >
              <FaFileExcel />
              <span className="ml-2 ocultar-mobile">
                {isLoadingExcel ? 'Salvando...' : 'Salvar'}
              </span>
            </Button>
          </Col>
        </Row>
      </div>
      <Row className="p-4">
        {isLoading ? (
          <Col className="text-center">
            <Loading label="Buscando imóveis..." />
          </Col>
        ) : (
          <>
            {error && (
              <Col xs={12}>
                <div className="alert alert-danger">{error}</div>
              </Col>
            )}
            {imoveis && imoveis.length > 0 ? (
              <Col xs={12} className="bg-white table-responsive">
                <Table className="table table-striped table-bordered table-hover p-3">
                  <Thead>
                    <Tr className="text-center font-size-14">
                      <Th>Família</Th>
                      <Th>Descrição</Th>
                      <Th>Cidade</Th>
                      <Th>Imóveis</Th>
                      <Th>Comercial</Th>
                      <Th>Misto</Th>
                      <Th>Residencial</Th>
                      <Th>Vertical</Th>
                      <Th>+</Th>
                    </Tr>
                  </Thead>
                  <Tbody className="text-center font-size-13">
                    {imoveis.map((item, idx) => (
                      <Tr key={idx}>
                        <Td>{item.codigo_familia}</Td>
                        <Td>{item.nome_da_familia}</Td>
                        <Td>{item.cidade}</Td>
                        <Td>{item.imoveis}</Td>
                        <Td>{item.comercial}</Td>
                        <Td>{item.misto}</Td>
                        <Td>{item.residencial}</Td>
                        <Td>{item.vertical}</Td>
                        <Td>
                          <a
                            className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                            href={`/mapa-empreendimento/${item.codigo_familia}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaThLarge className="mr-1" />
                            Mapa
                          </a>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </Col>
            ) : (
              <Col className="text-center">
                <p className="text-muted">Nenhum imóvel encontrado</p>
              </Col>
            )}
          </>
        )}
      </Row>
    </>
  );
}
